import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SERVICES } from "@/lib/data";
import Reveal from "@/components/site/Reveal";

const TONE = {
  magenta: "rgba(201,42,107,0.14)",
  teal: "rgba(0,107,102,0.16)",
  emerald: "rgba(15,122,84,0.16)",
};

export default function Services() {
  return (
    <section id="services" className="relative py-24 md:py-40 bg-[#0A0607]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-body text-xs tracking-[0.4em] uppercase text-[#D4AF37] mb-4">What We Cater</p>
          <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl text-[#FDFBF7] leading-[0.95] max-w-3xl">
            Occasions worthy of a <span className="gold-gradient-text italic">palace.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 mt-16">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <motion.div
                whileHover={{ y: -8 }}
                transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`service-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group relative h-full rounded-tl-[2.5rem] rounded-br-[2.5rem] border border-[#D4AF37]/15 hover:border-[#D4AF37]/60 overflow-hidden transition-colors duration-500"
                style={{ backgroundColor: TONE[s.tone] }}
              >
                <div className="h-56 overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                  />
                  <div className="absolute top-0 left-0 right-0 h-56 bg-gradient-to-t from-[#0A0607] to-transparent" />
                </div>
                <div className="p-8">
                  <h3 className="font-display text-3xl md:text-4xl text-[#FDFBF7] mb-3">{s.title}</h3>
                  <p className="font-body text-[#A89F91] leading-relaxed mb-6">{s.desc}</p>
                  <ul className="space-y-2">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-center gap-3 font-body text-sm text-[#FDFBF7]/80">
                        <Check size={15} className="text-[#D4AF37]" /> {f}
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
